import { useBreakpoint, Breakpoints } from '@nextgen-web-framework/all';
import LanguageModal from '../LanguageModal/LanguageModal';
import useLanguageSelector from '../../utils/useLanguageSelector';
import { MePanelLanguageContainerProps } from './types/propTypes';
import styles from './MePanelLanguage.module.scss';
const MePanelLanguage = ({ children, locale, langHandler }: MePanelLanguageContainerProps) => {
  const { showLanguageModal, onCloseHandler, languageClickHandler, handleLanguageChange } = useLanguageSelector({
    langHandler,
  });
  const viewPortType = useBreakpoint();
  const isMobile = [Breakpoints.SM, Breakpoints.XS].includes(viewPortType as Breakpoints);
  return (
    <div className={styles['me-panel-language-container']} data-testid="me-panel-language-test-id">
      <div
        onKeyDown={languageClickHandler}
        onClick={languageClickHandler}
        role="presentation"
        data-testid="language-button-test-id"
      >
        {children}
      </div>
      {showLanguageModal && (
        <LanguageModal
          hasBackButton={isMobile ? false : true}
          languageHandler={handleLanguageChange}
          currentLocale={locale}
          onClose={onCloseHandler}
        />
      )}
    </div>
  );
};

export default MePanelLanguage;
